import MenuTop from './menu-top/menu-top.vue'

export default {
  'components': {
    'menu-top': MenuTop
  },
  'data': function () {
    return {

    }
  },
  'created': function () {
  },
  'mounted': function () {
  },
  'methods': {

  }
}



// WEBPACK FOOTER //
// ./src/component/app.js